import React from "react";
import { Link } from "react-router-dom";
import { Beer, ArrowRight } from "lucide-react";

/**
 * Placeholder mostrado en `/marcas` mientras `featureFlags.brandsPublic`
 * permanezca en `false`. El contenido real vive en `ForBrands.jsx` y queda
 * intacto, listo para reactivarse cambiando el flag.
 */
export default function ComingSoon() {
  return (
    <div className="bg-black text-[#F5F5F5] min-h-[60vh] flex items-center justify-center" data-testid="page-coming-soon">
      <div className="max-w-xl mx-auto px-6 py-20 text-center">
        <Beer size={36} className="mx-auto text-[#FEBA01] mb-3" />
        <div className="font-body font-bold text-xs uppercase tracking-[0.3em] text-[#FEBA01]">
          Próximamente
        </div>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl uppercase tracking-tight leading-[1]">
          Esta sección llega pronto
        </h1>
        <p className="mt-4 text-sm text-[#A3A3A3] leading-relaxed">
          Estamos preparando esta parte de Kiltro Scout. Vuelve en unos días o vuelve al inicio para seguir explorando la camada.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 bg-[#FEBA01] text-black font-display text-base uppercase tracking-wide px-5 py-2 shadow-brutal-white"
          data-testid="coming-soon-home-cta"
        >
          Ir al inicio <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}
